// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"beb_a bgu_bk bgu_bl bgu_bo","SwipeLeftToClose--animating":"beb_b"};